import React from 'react';
import './Navbar.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <nav>
            <ul>
                <li><a href="/" rel="noopener noreferrer">home</a></li>
                <li><Link to="/blog" rel="noopener noreferrer">blog</Link></li>
                <li><a href="/faq" rel="noopener noreferrer">faq</a></li>
                <li><a href="/stuff" rel="noopener noreferrer">stuff</a></li>
            </ul>
        </nav>
    );
};

export default Navbar;
